import { FC, useEffect, useState } from 'react'
import { Table } from 'reactstrap'

import { UserWithHourBalances } from '../../../../@paco/entities/HourBalances/HourBalances'

import FixedTableHeader from '../../../../components/FixedTableHeader/FixedTableHeader'
import UsersWithLoketBalancesHead from './subcomponents/UserWithHourBalancesHead/UserWithHourBalancesHead'
import UserWithHourBalancesRow from './subcomponents/UserWithHourBalancesRow/UserWithHourBalancesRow'

import './UsersWithHourBalancesTable.scss'

interface UsersWithHourBalancesTableProps {
    isLoading: boolean;
    users: UserWithHourBalances[];
}

const UsersWithHourBalancesTable: FC<UsersWithHourBalancesTableProps> = ({
    isLoading,
    users,
}) => {
    const [userList, setUserList] = useState<UserWithHourBalances[]>(users || [])

    useEffect(() => {
        if (! isLoading && users.length) {
            setUserList(users)
        }
    }, [users, isLoading])

    return (
        <div className="users-with-loket-balances-table table-container-responsive">
            <div className="table-container">
                <div>
                    <Table>
                        <UsersWithLoketBalancesHead />
                        <tbody>
                            {userList.map((user: UserWithHourBalances) => (
                                <UserWithHourBalancesRow
                                    key={user.userId}
                                    {...user}
                                />
                            )) }
                        </tbody>
                    </Table>
                    <FixedTableHeader className="users-with-loket-balances-table__fixed-table-header">
                        <Table>
                            <UsersWithLoketBalancesHead />
                        </Table>
                    </FixedTableHeader>
                </div>
            </div>
        </div>
    )
}

export default UsersWithHourBalancesTable
